import { tokens } from "@opendoor/tokens-studio/dist/bricks-next/tokens/Components";
import { isWeb, styled, View } from "@tamagui/core";
import { isKeyOfObject } from "../../../helpers/utils.mjs";
const {
    textInput: textInputTokens
  } = tokens,
  InputFrame = styled(View, {
    backgroundColor: textInputTokens.color.background.default,
    flexDirection: "row",
    gap: textInputTokens.padding.gap.textAndIcon.default,
    animation: "fastEaseOut",
    animateOnly: isWeb ? ["border-color", "border-top-color", "border-left-color", "border-bottom-color", "border-right-color"] : ["borderColor", "borderTopColor", "borderLeftColor", "borderBottomColor", "borderRightColor"],
    variants: {
      size: size => ({
        borderRadius: textInputTokens.cornerRadius[size],
        paddingVertical: textInputTokens.padding.topBottom[size],
        paddingHorizontal: textInputTokens.padding.leftRight[size]
      }),
      state: state => {
        const backgroundColor = isKeyOfObject(state, textInputTokens.color.background.state) ? textInputTokens.color.background.state[state] : textInputTokens.color.background.default,
          borderColor = state ? textInputTokens.color.border.state[state] : textInputTokens.color.border.default,
          borderWidth = textInputTokens.borderWidth.default,
          hoverStyle = state ? {} : {
            borderColor: textInputTokens.color.border.state.hover
          };
        return {
          backgroundColor,
          borderColor,
          borderWidth,
          hoverStyle,
          cursor: state === "inactive" ? "default" : "text"
        };
      }
    }
  });
export { InputFrame };